import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { CheckCircle, Phone, ArrowRight, Home } from 'lucide-react';
import { Button } from '@/components/ui/button';

const ThankYouPage = () => {
  const openWhatsApp = () => {
    window.open('https://wa.me/919958848998?text=Hello%20Zafco,%20I%20just%20submitted%20a%20form%20on%20your%20website', '_blank');
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center py-20" data-testid="thankyou-page">
      <div className="container mx-auto px-6">
        <motion.div
          className="max-w-2xl mx-auto text-center"
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
        >
          <div className="w-24 h-24 rounded-full bg-green-100 flex items-center justify-center mx-auto mb-8">
            <CheckCircle className="w-14 h-14 text-green-500" />
          </div>

          <h1 className="text-3xl md:text-4xl font-bold text-zafco-blue font-montserrat mb-4">
            Thank You for Contacting Us!
          </h1>
          
          <p className="text-xl text-gray-600 mb-8">
            Your inquiry has been received. Our expert team at Zafco Human Resource Management 
            will review your profile and contact you within 24 hours.
          </p>

          <div className="bg-gray-50 rounded-2xl p-8 mb-8">
            <h3 className="text-lg font-bold text-zafco-blue mb-4">What Happens Next?</h3>
            <div className="space-y-4 text-left">
              {[
                'Our expert will review your profile within 24 hours',
                'You\'ll receive a personalized assessment via WhatsApp/Email',
                'We\'ll schedule a free consultation call',
                'Get customized immigration pathway recommendations',
              ].map((step) => (
                <div key={step} className="flex items-start gap-3">
                  <CheckCircle className="w-5 h-5 text-green-500 mt-0.5" />
                  <span className="text-gray-700">{step}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button 
              onClick={openWhatsApp}
              className="bg-gradient-to-r from-zafco-gold to-zafco-orange text-white font-semibold"
            >
              <Phone className="w-5 h-5 mr-2" />
              Chat on WhatsApp Now
            </Button>
            <Link to="/">
              <Button variant="outline" className="border-zafco-blue text-zafco-blue">
                <Home className="w-5 h-5 mr-2" />
                Return to Home
              </Button>
            </Link>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default ThankYouPage;
